// extracted by mini-css-extract-plugin
export default {"grid":"QuestionList_grid__QXZQ3"};